import { render, staticRenderFns } from "./PriceListManager.vue?vue&type=template&id=d03c6224"
import script from "./PriceListManager.vue?vue&type=script&lang=js"
export * from "./PriceListManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports